import { inject } from '@angular/core';
import { InMemoryCache } from '@apollo/client/cache';
import { environment } from '@environments/environment';
import { provideNamedApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

export const apolloProviderService = provideNamedApollo(() => {
  const httpLink = inject(HttpLink);

  return {
    ContractorGraphQL: {
      cache: new InMemoryCache(),
      link: httpLink.create({
        uri: environment.graphql.contractor.url,
      }),
    },
    RBSGraphQL: {
      cache: new InMemoryCache(),
      link: httpLink.create({
        uri: environment.graphql.rbs.url,
      }),
    },
  };
});
